module.exports = __webpack_public_path__ + "static/media/welcome.0f0d610a.png";